import { IMessageBarStyles, MessageBar, MessageBarType } from "@fluentui/react";
import React from "react";

import { Text } from "./Text";

export interface ErrorMessageProps {
    text?: string;
    stack?: string;
    showStack?: boolean;
    styles?: IMessageBarStyles;
}

export const ErrorMessage: React.FunctionComponent<ErrorMessageProps> = (props: ErrorMessageProps) => {
    const { text, stack, showStack, styles = { root: { margin: "10px" } } } = props;

    if (!showStack || !stack) {
        return (
            <MessageBar messageBarType={MessageBarType.error} isMultiline={true} styles={styles}>
                <Text block={false} nowrap={false} variant="smallPlus">
                    {text || defaultText}
                </Text>
            </MessageBar>
        );
    }

    return (
        <MessageBar messageBarType={MessageBarType.error} styles={styles} isMultiline={true}>
            <Text block={false} nowrap={false} variant="smallPlus">
                {text || defaultText}
            </Text>
            <div style={{ padding: "10px" }}>
                <Text block={false} nowrap={false} variant="smallPlus">
                    {stack}
                </Text>
            </div>
        </MessageBar>
    );
};

const defaultText = "Unexpected error has occured. Please contact support team.";
